export default defineAppConfig({
  theme: {
    primaryColor: '#ababab'
  }
  // ui: {
  //     primary: 'green'
  // }
  //  myticketsApiBaseRoute: `/v2/mytickets`,
})
